export default __webpack_public_path__ + "static/x-feca8f0f4798b71156fd4c558c6670d6.svg";